var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5714 18H20.4C20.7314 18 21 17.7314 21 17.4V11C21 8.79086 19.2091 7 17 7H7C4.79086 7 3 8.79086 3 11V17.4C3 17.7314 3.26863 18 3.6 18H6.42857",
    stroke: "#222222",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7V3.6C8 3.26863 8.26863 3 8.6 3H15.4C15.7314 3 16 3.26863 16 3.6V7",
    stroke: "#222222",
    strokeWidth: 1.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09794 20.3151L6.42867 18L6.92651 14.5151C6.96874 14.2196 7.22189 14 7.52048 14H16.4797C16.7783 14 17.0314 14.2196 17.0737 14.5151L17.5715 18L17.9022 20.3151C17.9539 20.6766 17.6734 21 17.3083 21H6.69191C6.32678 21 6.0463 20.6766 6.09794 20.3151Z",
    stroke: "#222222",
    strokeWidth: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.0101L17.01 9.99902",
    stroke: "#222222",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintPage);
export default __webpack_public_path__ + "static/media/printPage.f246c739e4371cc323924c390e411577.svg";
export { ForwardRef as ReactComponent };